<div class="tree-node">
  <div class="set-title">
    <mat-radio-button [checked]="isChecked" [value]="categoryId" (change)="selectionChanged($event)" [disabled]="disableNodeAndChildren">
      <span class="name">
        {{ node.label }}
      </span>
    </mat-radio-button>
  </div>
</div>

<div class="sub-nodes">
  <mood-select-category-tree-node *ngFor="let subNode of childNodes" [node]="subNode" [selectedNode]="selectedNode" (selectedNodeChange)="emitSelectedNode($event)" [forceDisable]="disableNodeAndChildren" [nodeToDisable]="nodeToDisable"></mood-select-category-tree-node>
</div>
